var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "body",
      {
        staticClass:
          "home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container",
        staticStyle: { "overflow-y": "unset", "background-color": "#f5f7f7" },
        attrs: { "data-anchor": "pagetop" }
      },
      [
        _c("navbar", {
          attrs: {
            follow: "st-Header",
            imgSrc: "../../../../static/img/logo/logo-black.png"
          }
        }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("copyright")
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "st-MainContainer col-12" }, [
      _c(
        "main",
        {
          staticClass: "st-MainContents",
          staticStyle: { "padding-top": "120px" }
        },
        [
          _c("header", { staticClass: "news-PageTitle" }, [
            _c("div", { staticClass: "news-PageTitle_Inner" }, [
              _c(
                "h1",
                {
                  staticClass: "sw-Section_Header appear",
                  attrs: { "data-appear": "" }
                },
                [
                  _c("span", { staticClass: "sw-Section_Header-en" }, [
                    _c("b", [_vm._v("SITE POLICY")])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "sw-Section_Header-ja" }, [
                    _c("b", [_vm._v("サイトポリシー")])
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "policy-Block" }, [
            _c("div", { staticClass: "policy-Block_Inner" }, [
              _c("div", [
                _c("h2", [_vm._v("免責事項")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                株式会社ロボティクスソリューションズ、及びその関連会社（以下、「当社」といいます）のウェブサイトからリンクされたサイト・当社ウェブサイトへリンクするサイト(以下「リンクサイト」と呼びます)の内容は、当社の管理下にあるものではありませんので、それぞれのリンクサイトの使用条件に従ってご利用ください。当社はそれらをご利用したことによる損害についても責任を負いません。"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n                掲載されている情報のその正確性と最新性の確保に努めていますが、完全さを保証するものではありません。利用者が当ウェブサイトの情報を用いて行う一切の行為について、当社が何ら責任を負うものではありません。また、当ウェブサイトは、予告なしに内容を変更または削除することがありますので、あらかじめご了承ください。\n              "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("h2", [_vm._v("著作権")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                当ウェブサイトに収録されている記載事項、写真、動画、音声、製品の説明文章等、すべてのコンテンツの著作権は当社に帰属します。但し、外部依託先の制作や掲載作品等で当社以外に著作者が存在する場合については、原則として各著作者に帰属します。"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n                利用者個人で使用（複製、送信、頒布、譲渡、翻案等）する以外に、当ウェブサイトの文章、画像等を他のウェブサイトや印刷媒体に転載することはできません。また、その他著作権法で認められている範囲を超えて、当ウェブサイトに収録されているコンテンツを著作権者に無断で使用することはできません。当社からの事前の書面による承諾なしに、当該情報の無断転用を禁じます。\n              "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("h2", [_vm._v("ソーシャルメディア利用に関して")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "ソーシャルメディアから発信する情報は、ソーシャルメディアの特性上、情報の正確性および完全性を保証するものではありません。当社および当社従業員が本アカウントで発信する情報については、必ずしも当社の公式発表・見解を表すものではありません。公式見解・発表は、当ウェブサイトをご覧ください。"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("h2", [_vm._v("準拠法")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "当ウェブサイトは、法律の異なる全世界の国々からアクセスすることが可能ですが、当ウェブサイトにアクセスされたご利用者および当社の両者は、当ウェブサイトの利用に関して日本国の法律に拘束されることに同意するものとします。"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("h2", [_vm._v("禁止事項について")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "当ウェブサイトのご利用に際し、次の行為をしてはならないものとします。"
                  )
                ]),
                _vm._v(" "),
                _c("ol", [
                  _c("li", [
                    _vm._v(
                      "1.第三者もしくは当社の財産もしくはプライバシー等を侵害する行為、または侵害する恐れのある行為。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "2.第三者もしくは当社に、不利益もしくは損害を与える行為、またはその恐れのある行為。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v("3.公序良俗に反する行為、またはその恐れのある行為。")
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "4.犯罪行為もしくは犯罪行為に結びつく行為、またはその恐れのある行為。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "5.他人の電子メールアドレスを登録する等、虚偽の申告、届出を行なう行為。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "6.営業活動もしくは営利を目的とする行為、またはその準備を目的とする行為。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "7.第三者もしくは当社の名誉もしくは信用を毀損する行為。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "8.コンピュータウィルス等有害なプログラムを使用もしくは提供する行為、またはその恐れのある行為。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "9.その他、法律、法令もしくは条例に違反する行為、またはその恐れのある行為。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [_vm._v("10.その他、当社が不適切と判断する行為。")])
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "st-Breadcrumbs" }, [
        _c(
          "ul",
          {
            staticClass: "st-BreadcrumbsList",
            attrs: { itemscope: "itemscope", itemtype: "" }
          },
          [
            _c(
              "li",
              {
                staticClass: "st-BreadcrumbsList_Item",
                attrs: {
                  itemprop: "itemListElement",
                  itemscope: "itemscope",
                  itemtype: ""
                }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "st-BreadcrumbsList_Item-link",
                    attrs: { href: "/", itemprop: "item" }
                  },
                  [_vm._v("ホーム")]
                ),
                _vm._v(" "),
                _c("meta", { attrs: { itemprop: "position", content: "1" } })
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "st-BreadcrumbsList_Item",
                attrs: {
                  itemprop: "itemListElement",
                  itemscope: "itemscope",
                  itemtype: ""
                }
              },
              [
                _c(
                  "p",
                  {
                    staticStyle: { "margin-bottom": "0rem" },
                    attrs: { itemprop: "item", "aria-current": "page" }
                  },
                  [
                    _c("span", { attrs: { itemprop: "name" } }, [
                      _vm._v("サイトポリシー")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("meta", { attrs: { itemprop: "position", content: "3" } })
              ]
            )
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04f3c978", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04f3c978","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/policy/policy.vue
// module id = null
// module chunks = 